<template>
  <div>
    <div id="Subidor_div_SINOJ_VSBARCH" class="">
      <div id="ContenidoSubidor_div" style="display: flex">      
        <div id="subidordearchivos_div_SINOJ_VSBARCH" class="col-12">
          <div id="descargaPlantila_div">          
            <CEleccionDePlantilla
                                  v-on:obtenerPlantilla="obtenerPlantilla"
                                  :idComponente="'plantilla_CreacionCedula'"
                                  :ref="'creacionCedula_ref'"
                                  :filtrosDePlantillas="parametros_Plantillas"
                                  :eleccionPara="'Cédula'"
                                  :archivoSubirExtensionesValidas="'.DOC,.DOCX.,.PDF'"
                                  :valorDefinidoCatalogo="parametros_Plantillas.tipoPlantillaId"
                                  :contadorRender="parametros_Plantillas.contRende"
                                  :conSubidorDeArchivo="false"></CEleccionDePlantilla>            
        </div>          
        <!-- <div class="area" v-if="plantilla.plantillaObj.TipoPlantillaId > 0">
            <h6>Comentarios</h6><br/>            
            <div class="col-12 contenedor-color-negro"><textarea class="form-control" rows="4" v-model="plantilla.comentarios"></textarea></div>            
        </div>   -->    
        <div id="opciones-marcadores" class="card" style="margin-top: 3em;" v-if="plantilla.plantillaObj.TipoPlantillaId > 0">
          <div class="card-header">
              <h5><strong>Marcadores adicionales para el documento</strong></h5>
          </div>
          <div class="card-body">
            <div class="row no-gutters" v-if="plantilla.plantillaObj.TipoPlantillaId > 0">
              <!-- OPCIONES PARA LOS MARCADORES -->
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-0 d-flex">
                <div v-for="(marcador, index) in Object.values(MARCADORES)" :key="'M-OPS-' + index" class="pr-4">
                  <h6>
                    <i @click="evtAccionEnMarcadores(marcador)" 
                                :class="(!marcador.activo) ? 'far fa-square texto-filtros' : 'fas fa-check-square texto-filtros'"
                                style="cursor: pointer;"></i>&nbsp;&nbsp;{{ marcador.descripcion }}
                  </h6>
                </div>
              </div>
              <!-- INPUTS HABILITADOS PARA LOS MARCADORES -->
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-0" v-if="Object.values(MARCADORES).some(m => m.activo)">
                <hr style="height:1px;border:none;color:#FFF;background-color:rgb(75, 75, 75); margin-top:9px; margin-bottom:1em;"/>
                <!-- COMENTARIOS -->
                <div v-if="MARCADORES.COMENTARIOS.activo" class="form-group">
                  <label for="">[ <i class="fas fa-marker"></i> ]&nbsp;&nbsp;&nbsp;&nbsp;Comentarios adicionales en plantilla </label>
                  <textarea class="form-control pt-2" rows="4" v-model="plantilla.comentarios"></textarea>
                </div>
                <!-- ANEXOS -->
                <div v-if="MARCADORES.ANEXOS.activo" class="form-group">
                  <label for="">[ <i class="fas fa-marker"></i> ]&nbsp;&nbsp;&nbsp;&nbsp;Anexos de expediente </label>
                  <div v-show="habilitarOrdenamientoAnexos">
                    <div class="form-inline flex-wrap mt-2" style="gap: 1rem !important;">
                      <h6>
                        <i @click="ordenarAnexos({ tipoOrdenamiento: ordenamientoAnexos.TIPOS.NUMERO })" 
                            :class="(!ordenamientoAnexos.opciones.porNumero.activo) ? 'far fa-square' : 'fas fa-check-square'"
                            style="cursor: pointer;"></i>&nbsp;&nbsp;listar por numero
                      </h6> 
                      <h6>
                        <i @click="ordenarAnexos({ tipoOrdenamiento: ordenamientoAnexos.TIPOS.LETRA })" 
                            :class="(!ordenamientoAnexos.opciones.porLetra.activo) ? 'far fa-square' : 'fas fa-check-square'"
                            style="cursor: pointer;"></i>&nbsp;&nbsp;listar por letra
                      </h6> 
                      <h6>
                        <i @click="ordenarAnexos({ tipoOrdenamiento: ordenamientoAnexos.TIPOS.NINGUNO })" 
                            :class="(!ordenamientoAnexos.opciones.sinOrdenamiento.activo) ? 'far fa-square' : 'fas fa-check-square'"
                            style="cursor: pointer;"></i>&nbsp;&nbsp;sin listar
                      </h6> 
                    </div>
                    <div class="alert alert-dark" role="alert">
                      <h4 class="alert-heading">Sigue las Siguientes instrucciones!</h4>
                      <hr>
                      <ol type="1">
                        <li v-for="(instruccion,indexInst) in this.getOpsOrdenamientoSleccionada()" :key="indexInst" v-html="instruccion"></li>
                      </ol>
                    </div>
                  </div>
                  <div class="form-inline mb-3" style="gap: 1rem !important;">
                    <h6>Numero de filas a mostrar:</h6>
                    <select class="form-control form-control-sm" v-model="ordenamientoAnexos.rowsInput.seleccionado">
                      <option v-for="(numberRows,indexRow) in ordenamientoAnexos.rowsInput.opciones" :value="numberRows" :key="indexRow">{{ numberRows }}</option>
                    </select> 
                  </div>
                  <textarea class="form-control pt-2" :rows="ordenamientoAnexos.rowsInput.seleccionado" v-model="plantilla.anexos"></textarea>
                </div>
              </div>
            </div> 
          </div>
        </div>   
        <br />  
        <div v-if="plantilla.plantillaObj.TipoPlantillaId > 0" class="text-right" style="margin-bottom:2em;">                                                                      
          <button @click="crearPlantillaLlena()" type="button" class="btn btn-primary"><i class="fas fa-file-download"></i>&nbsp;&nbsp;Generar archivo con datos</button>
        </div>
        <!-- MODAL CONFORMACION ACUERDOS-->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-informativo">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Mensaje del sistema</h5>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <div class="form-group">
                            <h6>¿Deseas anexar los auerdos al sello?</h6>
                        </div>
                        <div class="row mt-4">
                            <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary mr-2" @click="accionesModal({ id: 'modal-informativo', accion: 'hide', opcion: true })"><i class="fas fa-check"></i>&nbsp;&nbsp;Si</button></div>
                            <div class="col-6 pr-1 pl-1"><button type="button" class="btn btn-block btn-primary" @click="accionesModal({ id: 'modal-informativo', accion: 'hide', opcion: false })"><i class="fas fa-times"></i>&nbsp;&nbsp;No</button></div>
                        </div>
                    </div>             
                </div>
            </div>
        </div>    
        <div class="card" v-if="urlDocumento != undefined && urlDocumento != ''">
          <div class="card-header">
              <h5><strong>Descargar el documento generado por el sistema</strong></h5>
          </div>
          <div class="card-body">
            <div class="d-flex align-items-center">
              <button @click="evtDescargarDocumento" type="button" class="btn btn btn-success"><i class="fas fa-file-download"></i>&nbsp;Descargar documento</button>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <h6>[ Documento generado con la infromacion capturada en el sistema ]</h6>
            </div>
          </div>
        </div>
        <!--   <div class="area" v-if="urlDocumento != undefined && urlDocumento != ''">
            <h6>Descargar el documento generado por el sistema</h6><br/>
            <div class="col-12 d-flex align-items-center">       
              <div ><button @click="evtDescargarDocumento" type="button" class="btn btn btn-success"><i class="fas fa-file-download"></i>&nbsp;Descargar documento</button></div>
            </div>
          </div>    -->       
          <br />

           <div class="card">
            <div class="card-header">
                <h5><strong>Subir documento para cedula (opcional)</strong></h5>
            </div>
            <div class="card-body">
              <div class="form-group">
                <h6>Seleccione el archivo (<i v-for="(tipoDoc, index) in parametros.extensionDocumento" :key="index">.{{tipoDoc}} <i v-if="index < parametros.extensionDocumento.length - 1">, </i></i>) a subir</h6><br/>
                <div class="col-12 d-flex align-items-center">            
                  <input type="file" id="archivoaSubir" v-on:change="cargarArchivo($event)" class="form-control" accept=".pdf,.doc,.docx" style="width: 100%"/>
                </div>
              </div>
            </div>
          </div>
         <!--  <div class="area">
            <h6>Seleccione el archivo (<i v-for="(tipoDoc, index) in parametros.extensionDocumento" :key="index">.{{tipoDoc}} <i v-if="index < parametros.extensionDocumento.length - 1">, </i></i>) a subir</h6><br/>
            <div class="col-12 d-flex align-items-center">            
              <input type="file" id="archivoaSubir" v-on:change="cargarArchivo($event)" class="form-control" accept=".pdf,.doc,.docx" style="width: 100%"/>
              linea comentada <div v-if="urlDocumento != undefined && urlDocumento != ''"><button @click="evtDescargarDocumento" type="button" class="btn btn btn-success"><i class="fas fa-file-download"></i>&nbsp;Descargar documento</button></div>
            </div>
          </div>     -->      
          <br />
          <div class="card">
                <div class="card-header">
                  <h5><strong>Documento</strong></h5>
                </div>
                <div class="card-body">
                    <div id="visor_contenedor">                        
                        <div id="visor_archivo">                                                 
                          <PDFDocument  
                          :url="urlDocumento" 
                          :height="'750px'" 
                          :ArchivoAConvertir="archivo"
                          :EsBase64="EsBase64"
                          :EsBlob = "EsBlob" 
                          :key="parametros_visorExternoPdf.key"/>
                        </div>
                    </div>
                                          
                </div>
           </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import comun from '@/../static/js/comun'
import funcion from '@/../static/js/api/comun/funcion/funcion';
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import axios from 'axios'
import CEleccionDePlantilla from '../Comun/CEleccionDePlantilla.vue'
import PDFDocument from '@/../src/components/Comunes/PDFDocument'
import { campoEsValido } from './Funciones/validaciones';
import { error } from 'jquery';

export default {    
    components: {
      comun,
      CEleccionDePlantilla,
      PDFDocument      
    },
    data: () => {
      return {
        EsBase64:{
                esBase64:false,
                archivoBase64:null
            },
            EsBlob:{
             esBlob:false,
             blob:null},
        ordenamientoAnexos: {
          valorTemporalMemoria: null,
          opciones: {
            porNumero: { activo: false, ref: 1 },
            porLetra: { activo: false, ref: 2 },
            sinOrdenamiento: { activo: true, ref: 3 },
          },
          TIPOS: {
            NUMERO: 1,
            LETRA: 2,
            NINGUNO: 3
          },
          INSTRUCCIONES: {
            1: [`Para agregar un nuevo anexo, <strong style="text-decoration: underline;">solo en este caso</strong> deberas hacer un salto de linea con la tecla <strong style="text-decoration: underline;">enter</strong>`, `Para iniciar el nuevo anexo deberas ingresar la siguiente nomencaltura:<span style="color: red !important; font-weight: bold;">" #) { informacion del anexo }"</span>, si no se respeta este formato no se podra hacer conversiones de tipo de ordenamiento del listado de anexos.`],
            2: [`Para agregar un nuevo anexo, <strong style="text-decoration: underline;">solo en este caso</strong> deberas hacer un salto de linea con la tecla <strong style="text-decoration: underline;">enter</strong>`, `Para iniciar el nuevo anexo deberas ingresar la siguiente nomencaltura:<span style="color: red !important; font-weight: bold;">" letra) { informacion del anexo }"</span>, si no se respeta este formato no se podra hacer conversiones de tipo de ordenamiento del listado de anexos.`],
            3: [`Para agregar un nuevo anexo, deberas separar los anexos por una coma`, `Para iniciar el nuevo anexo deberas ingresar la siguiente nomencaltura:<span style="color: red !important; font-weight: bold;">"anexo 1, anexo 2, ....."</span>, si no se respeta este formato no se podra hacer conversiones de tipo de ordenamiento del listado de anexos.`]
          },
          rowsInput: {
            opciones: [1,2,3,4,5,6,7,8,9,10,20,30,40,50,60,70,80,90,100],
            seleccionado: 2
          }
        },
        enumeraciones,        
        archivo: null,
        mensajeVisor: 'No se encuentra ningun archivo seleccionado.',
        urlDocumento: '', 
        plantilla: {
           plantillaObj: {},
           comentarios: '',
           anexos: '',
           conAcuerdos: false,
        },          
        parametros_Plantillas:{
          PlantillasDe: enumeraciones.sinoj.requierenPlantilla.cedula.llave,
          AreaId: null,
          TipoCedulaId: null,   
          TipoResultadoId: null,
          TipoRazonId: null,
          FechaInicial: null, 
          FechaFinal: null,                
          TipoPlantillaId: null,
          ConInactivos: false, EsPrueba: false,
          contRende: 0,
          key: ''
        },     
        parametros_visorExternoPdf: {
          key: ''
        },
        listaDeFamiliares: [9,10,22,34,57,86], // AreaID para pruebas - Tercero Civil: ,33    
        MARCADORES: {
          COMENTARIOS: { 
            descripcion: 'Comentarios', 
            activo: false
          },
          ANEXOS: { 
            descripcion: 'Anexos', 
            activo: false
          },
        },
        anexosDeExpedienteTMP: ''
      }
    },
    props: {
      parametros: Object,
      anexosDeExpediente: {
          type: Array,
          default: () => []
      },
    },
    computed: {
      habilitarOrdenamientoAnexos(){
        return(
          campoEsValido({ campoAValidar: this.plantilla.anexos }) 
            ? (this.ordenamientoAnexos.opciones.porNumero.activo || this.ordenamientoAnexos.opciones.porLetra.activo)
              ? true
              : this.plantilla.anexos.includes(',')
            : false
        );
      }
    },
    created() {
      this.unirAnexosDeExpediente();
    },
    mounted() {      
        this.parametros_Plantillas.AreaId = this.parametros.areaId;
        this.parametros_Plantillas.TipoCedulaId = this.parametros.tipoCedulaId;
        this.parametros_Plantillas.TipoResultadoId = this.parametros.tipoResultadoId;
        this.parametros_Plantillas.key = "plantillas_" + this.parametros_Plantillas.AreaId + this.parametros.tipoCedulaId;            
        if(this.parametros.url != undefined && this.parametros.url != null)
        {          
          this.urlDocumento = this.parametros.url;
          this.parametros_visorExternoPdf.key = "url_subidor" + this.urlDocumento;
        }
    },
    methods: {
      getOpsOrdenamientoSleccionada: function() {
        if(this.ordenamientoAnexos.opciones.porNumero.activo) {
          return this.ordenamientoAnexos.INSTRUCCIONES[1];
        }
        if(this.ordenamientoAnexos.opciones.porLetra.activo) {
          return this.ordenamientoAnexos.INSTRUCCIONES[2];
        }
        if(this.ordenamientoAnexos.opciones.sinOrdenamiento.activo) {
          return this.ordenamientoAnexos.INSTRUCCIONES[3];
        }
      },
      desctructurarOrdenamiento() { debugger
        let anexos = null;
        try {
          if(this.ordenamientoAnexos.opciones.porNumero.activo || this.ordenamientoAnexos.opciones.porLetra.activo) {
            let anexosArray = this.plantilla.anexos
              .split(/(\r\n|\n|\r)/gm)
              .map(a => {
                let anexoOriginalArray = a.split(')');
                anexoOriginalArray.shift();
                let anexoOriginal = anexoOriginalArray.join("").trim();
                return anexoOriginal;
              });
            anexos = anexosArray.filter(a => campoEsValido({ campoAValidar: a })).join(",");
          }
          else {
            anexos = this.plantilla.anexos;
          }
        }
        catch(err) {
          throw err;
        }
        return anexos;
      },
      ordenarAnexos: function({ tipoOrdenamiento }) { debugger
        const { TIPOS : { NUMERO, LETRA, NINGUNO } } = this.ordenamientoAnexos;
        try {
          let anexosOrdenados = `\n`;
          let anexosArray     = null;
          switch(tipoOrdenamiento) {
            case NUMERO:
                if(this.habilitarOrdenamientoAnexos) {
                  anexosArray = this.desctructurarOrdenamiento().split(',');
                  if(campoEsValido({ campoAValidar: anexosArray })) {
                    for(let i=0; i<anexosArray.length; i++) {
                      anexosOrdenados += `${ i + 1 })  ${ anexosArray[i] }\n`;
                    }
                    this.ordenamientoAnexos.rowsInput.seleccionado = (anexosArray.length + 2);
                  }
                }
              break;
            case LETRA:
              if(this.habilitarOrdenamientoAnexos) {
                  anexosArray = this.desctructurarOrdenamiento().split(',');
                  if(campoEsValido({ campoAValidar: anexosArray })) {
                    const LETRAS = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','ñ','o','p','q','r','s','t','u','v','w','x','y','z'];
                    const LONGITUD_LETRAS = LETRAS.length;
                    let indexLetras = 0;
                    for(let i=0; i<anexosArray.length; i++, indexLetras++) {
                      let identificadorParrafo = '';
                      if(i <= LONGITUD_LETRAS) {
                        identificadorParrafo = `${ LETRAS[indexLetras] }) `
                      }
                      else {
                        identificadorParrafo = `${ LETRAS[indexLetras] } - ${ i + 1 }) }`
                      }
                      anexosOrdenados += `${ identificadorParrafo }  ${ anexosArray[i] }\n`;
                    }
                    this.ordenamientoAnexos.rowsInput.seleccionado = (anexosArray.length + 2);
                  }
                }
              break;
            case NINGUNO:
              anexosOrdenados = this.desctructurarOrdenamiento();
              this.ordenamientoAnexos.rowsInput.seleccionado = 2;
              break;
            default:
              break;
          }
          for(let [key, opcionOrdenamiento] of Object.entries(this.ordenamientoAnexos.opciones)) {
            opcionOrdenamiento.activo = (opcionOrdenamiento.ref == tipoOrdenamiento);
          }
          this.plantilla.anexos = anexosOrdenados;
        }
        catch(error) {
          console.error(error.stack);
          console.error('ErrorOrdenandoAnexos::',error);
          alert('Ocurrio un error al ordenar los anexos');
        }
      },
      unirAnexosDeExpediente: function() {
        let anexosSTR = [];
        if(this.anexosDeExpediente != null && this.anexosDeExpediente != undefined && this.anexosDeExpediente.length > 0) {
          this.anexosDeExpediente.forEach(a => {
            let descripcionAnexo = `${ a.Cantidad } ${ a.Nombre }`;
            anexosSTR.push(descripcionAnexo);
          });
          this.anexosDeExpedienteTMP = anexosSTR.join(',');
        }
        this.plantilla.anexos = this.anexosDeExpedienteTMP;
        this.ordenamientoAnexos.valorTemporalMemoria = this.anexosDeExpedienteTMP;
      },
      evtAccionEnMarcadores: function(marcador) { debugger
        const { COMENTARIOS, ANEXOS } = this.MARCADORES;
        marcador.activo = !marcador.activo;

        if(marcador.descripcion == COMENTARIOS.descripcion)
          this.plantilla.comentarios = (!marcador.activo) ? null : this.plantilla.comentarios;

        if(marcador.descripcion == ANEXOS.descripcion) {
          this.plantilla.anexos = (!marcador.activo) ? this.anexosDeExpedienteTMP : this.plantilla.anexos;
          this.ordenamientoAnexos.opciones.sinOrdenamiento.activo = true;
          this.ordenamientoAnexos.opciones.porNumero.activo = false;
          this.ordenamientoAnexos.opciones.porLetra.activo = false;
          this.ordenamientoAnexos.rowsInput.seleccionado = 2;
        }
      }, 
      evtDescargarDocumento:function(){debugger
        if(this.urlDocumento != undefined){
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.href = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${this.urlDocumento}`
            a.click();
        }
      },
      crearPlantillaLlena: function() { debugger
        //alert(this.plantilla.comentarios);        
        if(this.listaDeFamiliares.includes(this.parametros_Plantillas.AreaId))
            $('#modal-informativo').modal('show');
        else 
          this.$emit('crearArchivo', this.plantilla); 
      },
      accionesModal: function({ id, accion, opcion }) {
            $('#' + id).modal(accion);            
            if(opcion)
              this.plantilla.conAcuerdos = opcion;
            this.$emit('crearArchivo', this.plantilla);
      },      
      obtenerPlantilla: function(plantilla){        
        this.plantilla.plantillaObj = plantilla;
        console.log('plantilla::',plantilla);
      },
      verificaQueSeaElDocumentoCorrecto: function(evento) {
        let siEsUnDocumentoValido = false; 
        console.log("archivo"); 
        console.log(evento.target.files);    
        //Se verifica que haya documento
        if(evento.target.files.length <= 0) {          
          $("#archivoaSubir").val('');
          this.archivo = null;     
          this.mensajeVisor = 'No hay ruta de archivo. Favor de volver a intentar.' 
          return siEsUnDocumentoValido;    
        }

        const nombreCortado = evento.target.files[0].name.split(".");        
        if (this.parametros.extensionDocumento.find(element => element.toLowerCase() == nombreCortado[nombreCortado.length - 1].toLowerCase()) != null)
          siEsUnDocumentoValido = true;
        else{
          let extensiones = "";
          this.parametros.extensionDocumento.forEach((element, index) => {
            extensiones += " ." + element;
            if(index < this.parametros.extensionDocumento.length - 1)
              extensiones += ",";
          });
          comun.mensajeDeAlerta("El documento que esta subiendo no es un archivo permitido. El archivo debe ser " + extensiones + ".<br/><br/>Verifique el documento e inténtelo de nuevo.", null, null);
          $("#archivoaSubir").val('');
          this.archivo = null; 
          
          return siEsUnDocumentoValido;
        }
        
        return siEsUnDocumentoValido;
      },
      cargarArchivo: function(evento) { 
        if(this.verificaQueSeaElDocumentoCorrecto(evento)) {                              
          //Almacenamos el archivo        
          this.archivo = evento.target.files[0];
          this.$emit('obtenerArchivo', this.archivo);               
         
          //Actualizamos visor
          const nombreCortado = evento.target.files[0].name.split(".");   
          this.urlDocumento = '';                    
          this.parametros_visorExternoPdf.key = "archivoDoc_subidor" + nombreCortado[0];
          console.log("URLDOCUMENTO::",this.urlDocumento)
          console.log("archivooo::",this.archivo)
        }        
      },         
    }
}
</script>
<style scoped>
  #Subidor_div_SINOJ_VSBARCH .card-header {
    background-color: rgb(70, 70, 70);
  }

   #Subidor_div_SINOJ_VSBARCH .card-body {
    background-color: rgb(49, 49, 49);
  }

  #Subidor_div_SINOJ_VSBARCH .card {
    border: 1px solid rgb(129, 129, 129) !important;
  }
  
  #modal-informativo .modal-lg {
      max-width: 30% !important;
  }

  #modal-informativo .modal-header {
      background-color: rgb(36, 34, 34);;
      border: none;
  }

  #modal-informativo .modal-dialog {
      position: relative;
      top: 40%;
      transform: translateY(-50%);
  }

  #Subidor_div_SINOJ_VSBARCH .card-header {
    background-color: var(--verde-pj);
  }

  #Subidor_div_SINOJ_VSBARCH .card-body {
    background-color: var(--gris-pj-100);
  }

  #Subidor_div_SINOJ_VSBARCH h6,
  #Subidor_div_SINOJ_VSBARCH label {
    color: black !important;
  }

  #Subidor_div_SINOJ_VSBARCH .btn-primary {
    background-color: var(--verde-pj-100);
  }
</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Comun/CSubidorDeArchivos.vue